import { z } from 'zod';
import { FeatureDetailSchema } from '../types/features.js';

// GET /accounts/:accountId/features
export namespace GetAccountFeatures {
  export const paramsSchema = z.object({
    accountId: z.coerce.number(),
  });

  export const responseSchema = z.object({
    features: z.array(FeatureDetailSchema),
  });

  export type Params = z.infer<typeof paramsSchema>;
  export type Response = z.infer<typeof responseSchema>;
}
